import { makeObservable, observable, action, runInAction, toJS } from 'mobx';
import {
  getServices,
  createService,
  updateService,
  deleteService
} from '../helpers/api';

class ServicesStore {
  _services = [];
  _selectedService = null;
  _isLoading = false;
  _error = null;
  _successMessage = null;

  constructor() {
    makeObservable(this, {
      _services: observable,
      _selectedService: observable,
      _isLoading: observable,
      _error: observable,
      _successMessage: observable,

      loadServices: action,
      createService: action,
      updateService: action,
      deleteService: action,
      setSelectedService: action,
      setError: action,
      setSuccess: action,
      clearMessages: action
    });
  }

  // Getters
  get services() {
    return toJS(this._services);
  }

  get selectedService() {
    return toJS(this._selectedService);
  }

  get isLoading() {
    return this._isLoading;
  }

  get error() {
    return this._error;
  }

  get successMessage() {
    return this._successMessage;
  }

  // Actions
  setError(error) {
    this._error = error;
  }

  setSuccess(message) {
    this._successMessage = message;
  }

  clearMessages() {
    this._error = null;
    this._successMessage = null;
  }

  async loadServices() {
    this._isLoading = true;
    this._error = null;

    try {
      const data = await getServices(false); // Load all services (active and inactive)
      runInAction(() => {
        this._services = data.services || [];
        this._isLoading = false;
      });
    } catch (err) {
      runInAction(() => {
        this._error = 'Erro ao carregar serviços';
        this._isLoading = false;
      });
      console.error('Failed to load services:', err);
    }
  }

  async createService(serviceData) {
    this._isLoading = true;
    this._error = null;

    try {
      await createService(serviceData);
      runInAction(() => {
        this._successMessage = 'Serviço criado com sucesso';
        this._isLoading = false;
      });
      await this.loadServices();
      return true;
    } catch (err) {
      runInAction(() => {
        this._error = err.message || 'Erro ao criar serviço';
        this._isLoading = false;
      });
      console.error('Failed to create service:', err);
      return false;
    }
  }

  async updateService(serviceId, serviceData) {
    this._isLoading = true;
    this._error = null;

    try {
      await updateService(serviceId, serviceData);
      runInAction(() => {
        this._successMessage = 'Serviço atualizado com sucesso';
        this._isLoading = false;
      });
      await this.loadServices();
      return true;
    } catch (err) {
      runInAction(() => {
        this._error = err.message || 'Erro ao atualizar serviço';
        this._isLoading = false;
      });
      console.error('Failed to update service:', err);
      return false;
    }
  }

  async deleteService(serviceId) {
    this._isLoading = true;
    this._error = null;

    try {
      await deleteService(serviceId);
      runInAction(() => {
        this._successMessage = 'Serviço removido com sucesso';
        this._isLoading = false;
      });
      await this.loadServices();
      return true;
    } catch (err) {
      runInAction(() => {
        this._error = err.message || 'Erro ao remover serviço';
        this._isLoading = false;
      });
      console.error('Failed to delete service:', err);
      return false;
    }
  }

  setSelectedService(service) {
    this._selectedService = service;
  }
}

const servicesStore = new ServicesStore();
export default servicesStore;